import React from 'react'

const ShoppingCartIcon = ({ className, size = 24, color = 'currentColor' }) => {
  return (
    <svg 
      className={className}
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="cart-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgba(150, 100, 255, 1)" />
          <stop offset="100%" stopColor="rgba(255, 100, 200, 1)" />
        </linearGradient>
        <filter id="cart-glow">
          <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      <path 
        d="M9 2L6.5 6M21 6H6.5M6.5 6L8 18C8.18 19.72 8.27 20.58 8.72 21.17C9.11 21.68 9.66 22.04 10.28 22.19C11 22.36 11.86 22.36 13.58 22.36H14.42C16.14 22.36 17 22.36 17.72 22.19C18.34 22.04 18.89 21.68 19.28 21.17C19.73 20.58 19.82 19.72 20 18L21 6M15 11V15M12 11V15M18 11V15M9 11V15" 
        stroke="url(#cart-gradient)" 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
        filter="url(#cart-glow)"
      />
      <circle cx="9" cy="21" r="1.5" fill="url(#cart-gradient)" filter="url(#cart-glow)" />
      <circle cx="17" cy="21" r="1.5" fill="url(#cart-gradient)" filter="url(#cart-glow)" />
    </svg>
  )
}

export default ShoppingCartIcon
